import React, {useState, useEffect} from "react";

import {useNavigate} from "react-router-dom";

//import redux
import {useSelector, useDispatch} from "react-redux";
import {RootState} from "../features/store";
import {
  selectCategoryAction,
  selectContainerAction,
  setServerSavedAction,
  updateContainer,
} from "../features/sliceReducer/myProjectReducer";

//import styled-component
import styled from "styled-components";

//import material-icon
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import HomeIcon from "@material-ui/icons/Home";
import IPUtility from "../classes/IPUtility";
import {toastPopupOpenAction} from "../features/sliceReducer/interactionReducer";
import {logOutAction} from "../features/sliceReducer/authReducer";

//styled
type ListContentsProps = {
  mainOpen?: boolean;
  subOpen?: boolean;
};

const ListContainer = styled.section`
  display: flex;
  align-items: center;
  /* margin: 20px; */
  color: ${({theme}) => theme.palette.text.primary};
`;

const ListArticle = styled.article`
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px 10px;

  &:not(:last-child)::after {
    content: "/";
    display: block;
    padding-left: 10px;
  }
`;

const ListHeader = styled.p`
  position: relative;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    color: ${({theme}) => theme.palette.primary.dark};
  }
  & span {
    display: block;
    padding-left: 12px;
  }
`;

const ListContents = styled.ul<ListContentsProps>`
  z-index: 100;
  display: ${(props) => (props.mainOpen || props.subOpen ? "block" : "none")};
  position: absolute;
  padding: 10px;
  width: max-content;
  top: 40px;
  color: ${({theme}) => theme.palette.text.secondary};
  line-height: 1.8;
  background-color: ${({theme}) => theme.palette.gray.light};
  border: 1px solid rgba(180, 180, 180, 0.1);
  box-shadow: 2px 2px 2px ${({theme}) => theme.palette.gray.light};
  transition: 0.3s ease;
  cursor: pointer;

  & li {
    cursor: pointer;
    &:hover {
      color: ${({theme}) => theme.palette.primary.dark};
    }
  }
`;

const ListSelect = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {myProject} = useSelector((state: RootState) => state.myProject);
  const {userToken} = useSelector((state: RootState) => state.auth);
  const {categoriesName, containerName, selectCategory, selectContainer} = useSelector(
    (state: RootState) => state.myProject
  );

  const [mainOpen, setMainOpen] = useState(false);
  const [subOpen, setSubOpen] = useState(false);
  const [mainCategory, setMainCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");

  useEffect(() => {
    setMainCategory(categoriesName);
    setSubCategory(containerName);
  }, [categoriesName, containerName]);

  const dispatchContainerAPI = (successHandler?: any, authFailHandler?: any, failHandler?: any) => {
    dispatch(setServerSavedAction(2));
    IPUtility.saveProjectToLocal(myProject, false);
    dispatch(
      updateContainer({
        userToken: userToken,
        item: IPUtility.dietContainer(IPUtility.getContainerByUID(myProject, selectContainer)),
        points: myProject.manualPointsList,
        projectUID: myProject.uid,
        noContentItemUIDs: myProject.noContentItemUIDs,
        successHandler: () => {
          IPUtility.saveProjectToLocal(myProject, true);
          dispatch(setServerSavedAction(1));
          dispatch(
            toastPopupOpenAction({
              contents: "저장되었습니다.",
              severity: "info",
            })
          );
          if (successHandler) successHandler();
        },
        authFailHandler: () => {
          IPUtility.saveProjectToLocal(myProject, false);
          dispatch(setServerSavedAction(0));
          dispatch(
            toastPopupOpenAction({
              contents: "로그아웃 됐습니다. 다시 로그인해주세요",
              severity: "error",
            })
          );
          dispatch(logOutAction());
          navigate("/login");
          if (authFailHandler) authFailHandler();
        },
        failHandler: () => {
          IPUtility.saveProjectToLocal(myProject, false);
          dispatch(setServerSavedAction(0));
          dispatch(
            toastPopupOpenAction({
              contents: "저장하지 못했습니다. 잠시 후 다시 해보세요",
              severity: "error",
            })
          );
          if (failHandler) failHandler();
        },
      })
    );
  };
  return (
    <>
      <ListContainer>
        <ListArticle>
          <ListHeader
            onClick={() => {
              dispatchContainerAPI(navigate("/inspect/myProject/" + myProject.uid));
            }}
          >
            <HomeIcon style={{paddingRight: "8px"}} />
            {myProject.name}
          </ListHeader>
        </ListArticle>
        <ListArticle>
          <ListHeader
            onClick={() => {
              setMainOpen(!mainOpen);
              setSubOpen(false);
            }}
          >
            {mainCategory}
            {mainOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </ListHeader>
          <ListContents mainOpen={mainOpen}>
            {myProject.categories.map(
              (category) =>
                category.name !== mainCategory && (
                  <li
                    key={category.uid}
                    onClick={(e) => {
                      window.scrollTo(0, 0);
                      dispatch(selectCategoryAction(category.uid));
                      dispatchContainerAPI();
                      dispatch(selectContainerAction(category.containers[0].uid));
                      setMainCategory(category.name);
                      setSubCategory(category.containers[0].name);
                      setMainOpen(!mainOpen);
                    }}
                  >
                    {category.name}
                  </li>
                )
            )}
          </ListContents>
        </ListArticle>

        {subCategory === "중분류 없음" ? null : (
          <ListArticle>
            <ListHeader
              onClick={() => {
                setSubOpen(!subOpen);
                setMainOpen(false);
              }}
            >
              {subCategory}
              {subOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </ListHeader>
            <ListContents subOpen={subOpen}>
              {myProject.categories.map((category) =>
                category.containers.map(
                  (container) =>
                    category.uid === selectCategory &&
                    container.name !== subCategory && (
                      <li
                        key={container.uid}
                        onClick={() => {
                          dispatchContainerAPI();
                          dispatch(selectContainerAction(container.uid));
                          setSubCategory(container.name);
                          setSubOpen(false);
                        }}
                      >
                        {container.name}
                      </li>
                    )
                )
              )}
            </ListContents>
          </ListArticle>
        )}
      </ListContainer>
    </>
  );
};

export default ListSelect;
